export default __webpack_public_path__ + "static/media/ico-mail-management.d99add64.svg";